import { render, staticRenderFns } from "./MilestonesList.vue?vue&type=template&id=8ce3a206&scoped=true&"
import script from "./MilestonesList.vue?vue&type=script&lang=js&"
export * from "./MilestonesList.vue?vue&type=script&lang=js&"
import style0 from "./MilestonesList.vue?vue&type=style&index=0&id=8ce3a206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce3a206",
  null
  
)

export default component.exports